import React, { FC } from "react";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import p2pManager from "../utils/p2pManager";
import { withRouter } from "./Root/withRouter";
import { Button } from "@chakra-ui/react";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";

interface Props {
	classroomName: string;
	isMonitoringClass: boolean;
	router: IComponentRouter;
}

const EndClassButton: FC<Props> = (props) => {
	const classroomId = useSelectedClassroomStore((state) => state.id);

	const handleEndSession = () => {
		void p2pManager.deleteXirsysChannel().catch(); // error already logged in deleteXirsysChannel
		p2pManager.close();
		if (props.isMonitoringClass) {
			void useClassroomSessionStore.getState().handleStartClassSession({
				classroomId: classroomId as string,
				expiry: 0,
				router: props.router,
				monitoringClass: true,
				force: false,
				inClassroom: false,
				classroomName: props.classroomName,
			});
		} else {
			void useClassroomSessionStore.getState().handleStartClassSession({
				classroomId: classroomId as string,
				expiry: 0,
				router: props.router,
				classroomName: props.classroomName,
			});
		}
	};

	return (
		<Button
			onClick={handleEndSession}
			ml="10px"
			px="10px"
			border="solid 1px #cdcdcd"
			borderRadius="6px"
			background="brand.400"
			cursor="pointer"
			height="32px"
			alignItems="center"
		>
			End Session
		</Button>
	);
};

export default withRouter(EndClassButton);
